"use client"

import type { WhyChooseUsProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { WhyChooseUsContent } from "./components/WhyChooseUsContent"
import { useWhyChooseUs } from "./hooks/useWhyChooseUs"

export const RenderConfig: ComponentConfig<WhyChooseUsProps> = {
  render: ({
    title,
    items,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: WhyChooseUsProps & { id?: string }) => {
    const { id } = useWhyChooseUs({
      items,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <WhyChooseUsContent id={id} title={title} items={items} className={twMerge(className)} />
      </>
    )
  },
}
